module.exports = __webpack_public_path__ + "static/media/REALlogo.fb5a924a.mp4";